import { Button } from 'components/ui/button';
import { Card, CardContent, CardTitle } from 'components/ui/card';
import { ModuleCompletionAnimation } from './ModuleCompletionAnimation';
import { useModuleCompletionAnimation } from './useModuleCompletionAnimation';

interface ModuleCompletionCardProps {
  title: string;
  primaryActionLabel: string;
  onContinue: () => void;
  onReturnToDashboard: () => void;
  isResolvingNextFlow?: boolean;
  nextChapterTitle?: string | null;
  returnLabel?: string;
}

export const ModuleCompletionCard = ({
  title,
  primaryActionLabel,
  onContinue,
  onReturnToDashboard,
  isResolvingNextFlow = false,
  nextChapterTitle,
  returnLabel = 'Return to Dashboard',
}: ModuleCompletionCardProps) => {
  const animationVariant = useModuleCompletionAnimation();
  return (
  <Card maxWidth="narrow" variant="glass" disableAnimation data-flow-surface="card">
    <ModuleCompletionAnimation variant={animationVariant} />
    <CardTitle
      centered
      title={<p className="leading-tight">Lesson complete</p>}
      subtitle={`You finished ${title}.`}
    />
    <CardContent variant="form" className="pt-4">
      {nextChapterTitle ? <p className="text-center text-sm text-muted-foreground">Next chapter: {nextChapterTitle}</p> : null}
      <Button
        variant="default"
        onClick={onContinue}
        className="min-w-0 max-w-full whitespace-normal sm:whitespace-normal"
        disabled={isResolvingNextFlow}
      >
        <span className="min-w-0 [overflow-wrap:anywhere]">{primaryActionLabel}</span>
      </Button>
      <Button
        variant="secondary"
        onClick={onReturnToDashboard}
        className="min-w-0 max-w-full whitespace-normal sm:whitespace-normal"
      >
        <span className="min-w-0 [overflow-wrap:anywhere]">{returnLabel}</span>
      </Button>
    </CardContent>
  </Card>
  );
};
